// extracted by mini-css-extract-plugin
module.exports = {"box":"standart-list_box__bVmK6","img_box":"standart-list_img_box__3jvqK"};